import { forwardRef } from 'react';
import { Map, MapProps, MapRef } from 'react-map-gl';
import config from '../../config';

const MAPBOX_TOKEN = config.mapbox.apiKey;

export const BloomfieldMap = forwardRef<MapRef, MapProps>(
  (props: MapProps, ref) => {
    return (
      <Map
        ref={ref}
        mapStyle='mapbox://styles/mapbox/satellite-streets-v12'
        {...props}
        mapboxAccessToken={`${MAPBOX_TOKEN}`}
      />
    );
  }
);
